import { LookupKeys } from '@ag-common-lib/lib/models/crm/lookup.model';
import { LookupBase } from '@ag-common-lib/lib/models/utils/lookup-base.model';

export enum PolicyVersionChangeKey {
  major = 'major',
  middle = 'middle',
  minor = 'minor',
}

export const policyVersionChangeMap = new Map([
  [PolicyVersionChangeKey.major, 'Major'],
  [PolicyVersionChangeKey.middle, 'Middle'],
  [PolicyVersionChangeKey.minor, 'Minor'],
]);

export const POLICY_VERSION_CHANGE_LOOKUP: LookupBase[] = Object.values(PolicyVersionChangeKey).map(
  value => {
    return { [LookupKeys.value]: value, [LookupKeys.description]: policyVersionChangeMap.get(value) };
  },
);
